<div
  class="header h-[55px] flex justify-start items-center mb-[18px] !bg-[#F1F3F5] sticky !z-20 top-0"
>
  <p class="!m-0 pl-[50px]">
    {{ projectName }} - Initiate Expression Of Interest
  </p>
  <p
    class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
  >
    Select Work Packages
  </p>
</div>

<div class="mt-[7px] ml-[30px] pl-[20px]">
  <div class="!pl-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0 !mb-[10px]" style="margin-right: 66px">
        <mat-form-field class="!w-[429px]" appearance="outline">
          <mat-label> Enter EOI Title </mat-label>
          <input
            matInput
            type="text"
            [formControl]="eoiTitleControl"
            placeholder="Enter EOI Title"
          />
          <mat-error
          *ngIf="eoiTitleControl.invalid && eoiTitleControl.touched"
          class="relative "
        >
          Title is required.
        </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <ng-container *ngIf="eoiData?.projectWPDetails?.length > 0">
    <div class="w-[100%] flex justify-between items-center">
      <div class="flex justify-start !h-[50px]">
        <label class="flex cursor-pointer">
          <input
            type="checkbox"
            class="h-[20px] w-[20px] mr-[12px]"
            [checked]="selectAllChecked"
            (change)="selectAllWorkPackages()"
          />
          <p class="packages-name text-[#3B71CA]">
            {{ selectAllChecked ? "Deselect All" : "Select All" }}
          </p>
        </label>
      </div>
    </div>
    <div
      *ngFor="let workpackage of eoiData?.projectWPDetails || []; let i = index"
      class="w-[100%] flex justify-between items-center"
    >
      <div class="flex justify-start !h-[50px]">
        <label class="flex cursor-pointer">
          <input
            type="checkbox"
            class="h-[20px] w-[20px] mr-[12px]"
            [checked]="isSelected(workpackage?.id)"
            (change)="toggleWorkPackageSelection($event, workpackage)"
          />
          <p class="packages-name">{{ workpackage?.work_package?.name }}</p>
        </label>
      </div>
    </div>
    <!-- <mat-error
      *ngIf="
        selectedWorkPackagesControl.invalid && selectedWorkPackagesControl.touched
      "
      class="relative bottom-4"
    >
      At least one work package must be selected.
    </mat-error> -->
  </ng-container>

  <div class="!pl-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%] !h-[130px]" appearance="outline">
          <mat-label> Additional Information </mat-label>
          <input
            matInput
            type="text"
            [formControl]="additionalInfoControl"
            placeholder="Additional Information"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="handleBack()" type="button" class="back-btn">Back</button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] !shadow-[0px_4px_4px_0px_rgba(0,_0,_0,_0.25)]"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>
